// Libraries
import { useEffect, useState } from "react";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import styled from "styled-components";
import { Select } from "semantic-ui-react";
import { SET_SURVEY_VERSION } from "constants/actions";

const SurveyVersions = ({
  label = false,
  hidden = false,
  selectedDebrief,
  dontRun,
}) => {
  const dispatch = useDispatch();
  const [selected, setSelected] = useState();
  const [questionList, setQuestionList] = useState();
  const [defaultValue, setDefaultValue] = useState();

  // Get the survey responses, sort them by id (which is a proxy for date)
  // and then get a list of the survey questions that have been used.
  const get_culture_audit_reports = useSelector(
    (state) => state.debrief_schedule.culture_audit_reports,
    shallowEqual
  );
  
  // Get the current survey version from Redux
  const survey_version = useSelector(
    (state) => state.audit?.survey_version,
    shallowEqual
  );
  
  // Initialize selected state from Redux when component mounts
  useEffect(() => {
    if (survey_version) {
      setSelected(survey_version);
    }
  }, [survey_version]);

  useEffect(() => {
    if (
      !dontRun &&
      selectedDebrief &&
      selectedDebrief?.sort_order &&
      questionList
    ) {
      let selected = questionList.find(
        (f) => f.id === selectedDebrief?.sort_order
      );
      setSelected(selected?.value);
    } else {
      if (selectedDebrief) {
        setSelected(questionList?.[0]?.value);
      }
    }
  }, [selectedDebrief, questionList]);

  useEffect(() => {
    if (!dontRun && get_culture_audit_reports && !questionList) {
      let sorted_responses = get_culture_audit_reports?.response?.sort(
        (a, b) => b.id - a.id
      );

      if (sorted_responses) {
        let surveys = [];
        sorted_responses.map((item) => {
          if (!surveys.find((f) => f.id == item.question.sort_order)) {
            surveys.push({
              id: item.question.sort_order,
              value: item.question,
              text: item.question.name,
            });
          }
        });

        setQuestionList(surveys);
        
        // If there's a saved survey version, use it; otherwise use the first one
        if (survey_version) {
          // Find the matching question in the surveys array
          const matchingSurvey = surveys.find(s => 
            s.value.sort_order === survey_version.sort_order
          );
          
          if (matchingSurvey) {
            setSelected(matchingSurvey.value);
          } else {
            setSelected(surveys?.[0]?.value);
          }
        } else {
          setSelected(surveys?.[0]?.value);
        }
      }
    }
  }, [get_culture_audit_reports, survey_version]);

  useEffect(() => {
    dispatch({
      type: SET_SURVEY_VERSION,
      payload: selected,
    });
  }, [selected]);

  if (questionList?.length > 1) {
    return (
      <Container hidden={hidden}>
        {label ? <Label>Survey Version</Label> : ""}
        <StyledSelect
          placeholder="Select Survey Type"
          options={questionList}
          enabled={!selectedDebrief}
          value={selected}
          id="anchors"
          onChange={(e, t) => {
            !selectedDebrief && setSelected(t.value);
          }}
        />
      </Container>
    );
  }

  return <div />;
};

export default SurveyVersions;

const StyledSelect = styled(Select)`
  font-family: "Inter", sans-serif !important;
  border-radius: 8px !important;
  border: 1px solid #e5e5e5 !important;
  font-size: 12px !important;
  color: #333 !important;
  min-width: 220px !important;
  margin-right: 15px;
  background-color: #f8f9fa !important;
  padding: 4px !important;
  display: flex !important;
  align-items: center !important;
  margin-bottom:-5px;
  margin-top:-5px;

  .item {
    font-size: 12px !important;
    color: #333 !important;
    font-family: "Inter", sans-serif !important;
  }
  
  .text {
    color: #333 !important;
    font-weight: 500 !important;
  }
  
  &:hover {
    border-color: #2D70E2 !important;
  }
`;

const Label = styled.div`
font-size: 10px;
color: #7e7e7e;
font-family: "Raleway", sans-serif !important;
margin-bottom:2px;
margin-left:5px;
font-weight:400;
`

const Container = styled.div`
display: ${props=>props.hidden?'none':'flex'};
flex-direction: column;
`
